import { Stack, Text } from '@trmediaab/zebra';
import PropTypes from 'prop-types';

import Time from '~/components/Time';

import PreliminaryEquipmentsTable from './PreliminaryEquipmentsTable';

export default function PreliminaryEquipmentsList({
  leg,
  bet_type,
  legs,
  preliminaryEquipments,
}) {
  const getLatestUpdate = preliminaryEquipments => {
    let latestDate;

    if (
      preliminaryEquipments &&
      Object.keys(preliminaryEquipments).length > 0
    ) {
      Object.values(preliminaryEquipments).map(ec => {
        if (ec != null) {
          Object.values(ec).map(preliminaryEquipment => {
            const updatedDate = new Date(preliminaryEquipment.updated);

            if (!latestDate || (latestDate && latestDate < updatedDate)) {
              latestDate = updatedDate;
            }
            return true;
          });
        }
        return true;
      });
    }

    return latestDate;
  };

  const arg = legs ? preliminaryEquipments : [preliminaryEquipments];
  const latestUpdate = getLatestUpdate(arg);

  return (
    <Stack between="3">
      {legs?.length > 0 && (
        <Text fontSize="2" color="brands.travrondenSpel" fontWeight="bold">
          Viktigaste ändringarna
        </Text>
      )}

      {/* Most important changes over multiple legs (overview) */}
      {legs?.length > 0 &&
        legs.map(
          leg =>
            preliminaryEquipments[leg.leg] && (
              <PreliminaryEquipmentsTable
                key={leg.leg}
                preliminaryEquipments={preliminaryEquipments[leg.leg]}
                bet_type={bet_type}
                legs={legs}
                leg={leg.leg}
              />
            ),
        )}

      {leg && (
        <PreliminaryEquipmentsTable
          leg={leg}
          bet_type={bet_type}
          preliminaryEquipments={preliminaryEquipments}
        />
      )}

      <Text fontSize="1" color="text.tertiary">
        Uppdateras löpande.{' '}
        {latestUpdate && (
          <Time
            date={new Date(latestUpdate)}
            format="'Senast uppdaterad kl' HH:mm"
          />
        )}
      </Text>

      <Text fontSize="1" color="text.tertiary">
        * Uppgifter om balans och vagn hämtas från Svensk Travsport.
        Informationen om huvudlag bygger på uppgifter som vi har tagit del av.
        Rödmarkerad text signalerar en förändring från senaste starten.
      </Text>
    </Stack>
  );
}

PreliminaryEquipmentsList.propTypes = {
  leg: PropTypes.number,
  bet_type: PropTypes.string,
  legs: PropTypes.array,
  preliminaryEquipments: PropTypes.any,
};
